import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { MoreVert } from "@mui/icons-material";

const ActionMenu = ({ actions = [], onOpen, onClose }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    if (onOpen) onOpen();
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    if (onClose) onClose();
  };

  const handleActionClick = (action, event) => {
    event.stopPropagation();
    if (action.onClick) action.onClick(event);
    handleCloseMenu();
  };

  return (
    <>
      {/* Trigger Button */}
      <IconButton
        onClick={handleOpenMenu}
        size="small"
        sx={{
          color: "text.secondary",
          "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
        }}
      >
        <MoreVert fontSize="small" />
      </IconButton>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          elevation: 3,
          sx: {
            borderRadius: 2,
            minWidth: 160,
            boxShadow:
              "0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A",
          },
        }}
      >
        {actions.map((action, index) => (
          <MenuItem
            key={index}
            disabled={action.disabled}
            onClick={(e) => handleActionClick(action, e)}
            sx={{
              color: action.color || "text.primary",
              "& .MuiListItemIcon-root": {
                color: action.iconColor || "inherit",
              },
              "&:hover": {
                backgroundColor: "action.hover",
              },
            }}
          >
            {action.icon && (
              <ListItemIcon>{action.icon}</ListItemIcon>
            )}
            <ListItemText primary={action.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ActionMenu;
